import api from '../services/api'

export default {
  namespaced: true,
  actions: {
    getItems ({ commit }, payload) {
      return api.getItems({ ...payload, expand: 'organization' })
        .then(response => ({
          items: response.data.items,
          totalCount: response.data.count
        }))
    },
  },
}
